import { Button, Col, Row, Table, Tooltip, Popconfirm } from "antd"
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import "./TableStyles.css";

const Columns = (loading, onEdit, onDelete) => [
    {
        title: 'Software',
        dataIndex: 'software',
        key: 'software',
    },
    {
        title: 'Dominio',
        dataIndex: 'nivel_dominio',
        key: 'nivel_dominio',
    },
    {
        title: 'Certificacion',
        dataIndex: 'certificacion',
        key: 'certificacion',
        render: (text) => text ? 'Si' : 'No',
    },
    {
        title: 'Acciones',
        dataIndex: 'acciones',
        width: "24%",
        align: 'center',
        render(_, record) {
            return (
                <>
                    <Row gutter={[8, 8]} justify="center">
                        <Col>
                            <Tooltip title="Editar idioma">
                                <Button
                                    loading={loading}
                                    size="small"
                                    onClick={() => onEdit(record)}
                                    icon={<EditOutlined />}
                                    shape='circle'
                                />
                            </Tooltip>
                        </Col>
                        <Col>
                            <Tooltip title="Eliminar idioma">
                                <Popconfirm
                                    title="¿Deseas eliminar esta herramienta?"
                                    onConfirm={() => onDelete(record.id_software)}
                                >
                                    <Button
                                        loading={loading}
                                        danger
                                        size="small"
                                        icon={<DeleteOutlined />}
                                        shape='circle'
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </Col>
                    </Row>
                </>
            )
        }
    },

];


const SofwareTable = ({ loading, catalog, onEdit, onDelete}) => {
    return (
        <>
            <Row>
                <Col span={24}>
                    <Table
                        rowClassName="editable-row"
                        rowKey={'id_software'}
                        className="my-custom-table"
                        size="small"
                        bordered
                        loading={loading}
                        columns={Columns(loading, onEdit, onDelete)}
                        dataSource={catalog}
                        pagination={{ position: ['bottomRight'], pageSize: 5 }}
                    />
                </Col>
            </Row>
        </>
    )
}

export default SofwareTable;